var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer",class:{toolbar: _vm.toolBar.show && _vm.toolBar.isNeed}},[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }